import styled from 'styled-components';

type PropsSiteAgentStyled = {};

export default styled.section`
  display: flex;
  flex-direction: column;
  .lock-status-container {
    margin-top: 28px;
    margin-bottom: 8px;
    padding-left: 32px;
    padding-right: 32px;
  }
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 start
  .error-message {
    color: red;
    padding: 0 50px;
    margin-top: 20px;
    margin-bottom: -15px;
  }
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 end
`;

export const SiteAgentStyled = styled.div<PropsSiteAgentStyled>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;

  .ant-table {
    .ant-table-content {
      .ant-table-thead {
        > tr {
          > th {
            padding: 11.5px 16px;
          }
        }
      }
      .ant-table-tbody {
        tr {
          td {
            padding: 11.5px 16px;
          }
        }
        tr:first-child {
          td:first-child {
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
          }
          td:last-child {
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
          }
        }
        tr:last-child td:first-child {
          border-bottom-left-radius: 8px;
        }
        tr:last-child td:last-child {
          border-bottom-right-radius: 8px;
        }
      }
    }
  }

  & .ant-table-container {
    width: 100vw;
    padding: 0 32px;
  }
  & .ant-table-wrapper {
    & .ant-table .ant-table-content .ant-table-thead {
      tr {
        th {
          &:first-child {
            padding-left: 24px;
          }
          &:last-child {
            padding-right: 24px;
          }
        }
      }
    }
    & .ant-table .ant-table-content .ant-table-tbody {
      tr {
        td {
          &:first-child {
            padding-left: 24px;
          }
          &:last-child {
            padding-right: 24px;
          }
        }
      }
    }
  }
  .separate {
    height: 8px;
  }
`;

interface PropStatusJobCP {
  color: string;
}

export const StatusJobStyled = styled.div<PropStatusJobCP>`
  width: 56px;
  height: 20px;
  border-radius: 4px;
  background-color: ${(props) => props.color};
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 18px;
`;
export const StatusRkyStyled = styled.div`
  .box-status {
    width: 96px;
    height: 20px;
    border-radius: 4px;
    background-color: #e65050;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 18px;
    .line {
      border-left: #ffffff solid 1px;
      height: 12px;
      margin: 0 8px;
    }
  }
`;
